import React from 'react';
import { TextField } from '@mui/material';

export const OutlinedInput = ({
  disabled,
  fullWidth,
  label,
  maxLength,
  minLength,
  required,
  multiline,
  rows,
  setValue,
  value,
}) => {
  return (
    <TextField
      disabled={disabled}
      id="outlined-basic"
      label={label}
      onChange={(event) => setValue(event.target.value, label)}
      required={required}
      value={value}
      variant="outlined"
      fullWidth={fullWidth}
      inputProps={{ maxLength: maxLength, minLength: minLength }}
      multiline={multiline}
      rows={rows}
    />
  );
};
